import { GlobalErrorType, IApiHeader } from "./appStoreTypes";
import { IFeedState } from "./feedStoreTypes";

export interface IAutoCompleteList {
  count: number;
  hashTagName: string;
  title: string;
}

export interface ISearchState extends IFeedState {
  tag: string;
}

export const initialSearchState: ISearchState = {
  page: 1,
  display: 20,
  list: [],
  tag: "",
  isLoadingList: true,
};

export interface IHashTagState {
  page: number;
  display: number;
  list: IAutoCompleteList[];
  isEmpty: boolean;
  type: "title" | "hashtag";
}

export const initialHashTagState: IHashTagState = {
  page: 1,
  display: 50,
  list: [],
  isEmpty: false,
  type: "title",
};

export interface ICurrentSearchState {
  searchValue: any;
  inputValue?: string;
}

export interface ISearchStore {
  searchState: ISearchState;
  onInitSearchList: () => void;
  onUpdateSearchList: (apiHeader: IApiHeader, tag?: string) => void;
  // onUpdateSearchType: (searchType: "hashtag" | "inputSearch") => void;

  autoCompleteState: IHashTagState;
  onInitHashtagList: () => void;
  onGetHashTagList: (
    apiHeader: IApiHeader,
    type: "hashtag" | "title",
    tag?: string
  ) => void;

  searchErrorState: GlobalErrorType;
  onUpdateSearchError: (type: GlobalErrorType) => void;
  currentSearchState: ICurrentSearchState;
  onUpdateCurrentSearch: (state: ICurrentSearchState) => void;
}
